import TokenPayload from "../types/TokenPayload";

const TOKEN_KEY = "token";
export const setToken = (token: string): void => {
    localStorage.setItem(TOKEN_KEY, token);
}

export const getToken = (): string | null => {
    return localStorage.getItem(TOKEN_KEY);
}

export const isAuthenticated = (): boolean => {
    return !!localStorage.getItem(TOKEN_KEY);
}

export const removeToken = (): void => {
    localStorage.removeItem(TOKEN_KEY);
}

export const getUserFromToken = (): TokenPayload | null => {
    const token = getToken();
    if (!token) return null;
    return getJwtBody(token)
}

export const getJwtBody = (token: any) => {
    if (!token) return null;

    const parts = token.split(".");
    if (!(parts.length > 0)) return null;

    const base64Url = parts[1]; // Extracting the payload part of the JWT
    if (!base64Url) return null;

    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/'); // URL-safe base64 decoding
    return JSON.parse(atob(base64)); // Decoding and parsing the JSON payload
};
